import { PayeeDetailDrawer } from '@/features/ap_payees/components/PayeeDetailDrawer';
import { r2wc } from '@/wc/helper/render';
import { useEffect } from 'react';

type Props = Record<string, never>;

const PayeeDetailDrawerWithInit = (props: Props) => {
  useEffect(() => {
    // Dispatch custom event when component is mounted
    const event = new CustomEvent('payee-drawer-ready', {
      bubbles: true,
    });
    window.dispatchEvent(event);
  }, []);

  return <PayeeDetailDrawer {...props} />;
};

export const DetailApPayeeDrawer = r2wc(PayeeDetailDrawerWithInit, {
  shadow: 'open',
});
